import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "@/components/Reveal";

const FAQS = [
  {
    q: "Pouvez-vous trouver n'importe quelle montre ?",
    a: "BABYLON peut rechercher de nombreuses marques, références et configurations grâce à son réseau de fournisseurs et de professionnels. Chaque recherche reste toutefois soumise à la disponibilité réelle du marché : nous vous présentons uniquement des opportunités concrètes et vérifiées.",
  },
  {
    q: "Combien coûte une recherche ?",
    a: "Les conditions sont communiquées en fonction de votre demande et de la montre recherchée. Vous recevez une proposition claire et détaillée avant toute validation — sans engagement de votre part à ce stade.",
  },
  {
    q: "Dois-je connaître la référence exacte ?",
    a: "Non. Vous pouvez simplement nous expliquer le modèle, le style ou les caractéristiques de la montre que vous recherchez. Notre équipe vous aide ensuite à identifier la référence correspondante.",
  },
  {
    q: "Comment fonctionne le paiement ?",
    a: "Vous validez d'abord la proposition qui vous est présentée. Selon les conditions de la transaction, un paiement ou un acompte peut ensuite être demandé afin de sécuriser l'acquisition auprès du fournisseur. Les modalités de paiement vous sont toujours communiquées clairement avant toute validation.",
  },
  {
    q: "Comment la montre est-elle vérifiée ?",
    a: "Chaque garde-temps fait l'objet d'un contrôle professionnel avant d'être proposé : examen de l'état, cohérence des composants, documentation et provenance. Nous vous communiquons l'ensemble des informations disponibles sur la pièce, en toute transparence.",
  },
  {
    q: "Quels sont les délais ?",
    a: "Ils dépendent du modèle recherché, de sa disponibilité sur le marché et des conditions d'acquisition. Certains modèles courants peuvent être trouvés rapidement ; les références rares demandent parfois une recherche plus approfondie.",
  },
  {
    q: "Pouvez-vous rechercher une montre rare ?",
    a: "Oui. BABYLON peut effectuer des recherches spécifiques sur des références rares, épuisées ou difficiles à trouver. C'est précisément la vocation de notre réseau.",
  },
];

export default function Faq() {
  return (
    <section id="faq" className="relative py-32 lg:py-48" data-testid="faq-section">
      <div className="max-w-4xl mx-auto px-5 sm:px-8">
        <SectionHeading
          eyebrow="Questions fréquentes"
          title={
            <>
              Tout ce que vous devez savoir,
              <br />
              <span className="italic text-gold">avant de nous confier votre recherche.</span>
            </>
          }
        />

        <Reveal delay={0.15}>
          <Accordion type="single" collapsible className="mt-14" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem key={f.q} value={`item-${i}`} className="border-white/[0.08]">
                <AccordionTrigger
                  className="text-left font-display text-lg sm:text-xl text-ivory hover:text-gold hover:no-underline py-6 transition-colors duration-300"
                  data-testid={`faq-question-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-sm sm:text-base text-stone2 leading-relaxed pb-7 max-w-2xl">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
